import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import logger from '../middlewares/logger'
import thunk from 'redux-thunk'
import artworkReducer from './reducers/artwork'
import favoriteReducer from './reducers/favorite'

const reducers = combineReducers({
  artwork: artworkReducer,
  favorite: favoriteReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(logger, thunk)),
  // applyMiddleware(logger, thunk) 
)

export default store